import { useState, useCallback } from 'react';
import { FriendlyColumn } from './types';

interface DBColumnsState {
  dbColumns: string[];
  friendlyColumns: FriendlyColumn[];
}

export const useDBColumns = () => {
  const [state, setState] = useState<DBColumnsState>({
    dbColumns: [],
    friendlyColumns: [],
  });

  const setColumns = useCallback((dbColumns: string[], friendlyColumns: FriendlyColumn[]) => {
    setState({ dbColumns, friendlyColumns });
  }, []);

  // Get grouped friendly columns
  const getGroupedFriendlyColumns = useCallback(() => {
    const grouped: Record<string, FriendlyColumn[]> = {};
    state.friendlyColumns.forEach(col => {
      if (!grouped[col.group]) {
        grouped[col.group] = [];
      }
      grouped[col.group].push(col);
    });
    return grouped;
  }, [state.friendlyColumns]);

  return {
    dbColumns: state.dbColumns,
    friendlyColumns: state.friendlyColumns,
    setColumns,
    getGroupedFriendlyColumns,
  };
};
